<template>
  <div
    class="wl-description-list overflow-hidden rounded-2xl border border-solid border-theme-transparent"
  >
    <div
      class="wl-description-list__header flex flex-col gap-2 border-b border-solid border-theme-transparent bg-muted p-3"
    >
      <slot name="header" />
    </div>
    <slot name="empty-state" />
    <div v-if="items.length" class="px-3">
      <dl class="m-0 flex w-full flex-col text-sm">
        <div
          v-for="{ key, value, tooltip } in items"
          :key="key"
          class="wl-description-list__item flex justify-between border-b border-solid border-b-muted py-2.5 text-emphasis last:border-b-0"
        >
          <dt class="flex gap-1">
            <template v-if="tooltip">
              <WLTooltip
                v-model:is-open="isTooltipOpen"
                placement="top"
                :size="TooltipSize.LARGE"
                :content="{
                  title: tooltip.title,
                  description: tooltip.description,
                }"
              >
                <template #anchor>
                  <div class="cursor-help underline decoration-dotted">
                    {{ key }}
                  </div>
                </template>
              </WLTooltip>
            </template>
            <template v-else>
              {{ key }}
            </template>
          </dt>
          <dd class="font-medium">
            {{ value }}
          </dd>
        </div>
      </dl>
    </div>
    <slot name="footer" />
  </div>
</template>
<script setup lang="ts">
import { ref, toRefs } from "vue";
import type { DescriptionListProps } from "./types";
import { WLTooltip } from "../tooltip";
import { TooltipSize } from "../tooltip/constants";

const props = defineProps<DescriptionListProps>();

const { items } = toRefs(props);

const isTooltipOpen = ref(false);
</script>
